
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-restart_alt",
  "use": "icon-material-restart_alt-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-restart_alt\"><path d=\"M451-115.78Q325.61-126.02 239.82-218.7q-85.8-92.67-85.8-220.06 0-77.48 35.5-146.08 35.5-68.59 99.5-112.55l48.74 48.74q-54.56 32.76-85.09 89.42-30.52 56.66-30.52 120.47 0 99.28 65.4 171.56 65.41 72.29 163.45 83.05zm60 0v-68.37q99.28-11.76 163.57-83.55 64.28-71.78 64.28-171.06 0-106.85-73.59-181.51t-180.43-76.1h-20.72l60.96 61.2-44.92 44.91-141.37-141.37 141.37-141.61 44.92 44.91-63.59 63.59h20.95q135.92 0 230.35 95.41 94.44 95.42 94.44 230.57 0 127.39-85.42 220.06-85.41 92.68-210.8 102.92\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-restart_alt"/>
                </svg>
            );
        };

        Icon.id = "icon-material-restart_alt";

        export default Icon;
    